<app-spinner-overlay></app-spinner-overlay>
<h2 mat-dialog-title>Obiettivo Aziendale</h2>
<div mat-dialog-content class="dialog-center-cont">
  <form [formGroup]="formObiettivoAziendalePiano" appFormContainer [larghezza]="2">
    <mat-form-field appFormElement [larghezza]="2" [riempi]="true">
      <mat-label>Titolo</mat-label>
      <textarea matInput placeholder="Titolo" formControlName="descrizione" [rows]="2"></textarea>
      <mat-error appFormError></mat-error>
    </mat-form-field>
    <mat-form-field appFormElement [larghezza]="2" [riempi]="true">
      <mat-label>Descrizione</mat-label>
      <textarea matInput placeholder="Descrizione" formControlName="note" [rows]="5"></textarea>
      <mat-error appFormError></mat-error>
    </mat-form-field>
  </form>
</div>
<div mat-dialog-actions class="dialog-footer-cont">
  <div>
    <button mat-dialog-close mat-flat-button color="accent" class="accent-button">Chiudi</button>
  </div>
  <div *ngIf="!this.data?.isPermessoSoloRead">
    <button mat-flat-button color="primary" (click)="salva()" class="primary-button">Salva</button>
  </div>
</div>
